import IconWithTitle from '@/shared/IconWithTitle/IconWithTitle';
import { useEffect, useState } from 'react';
import { StyledTaskActivityDetail } from '@/shared/TaskActivityDetail/TaskActivityDetail.styled';
import { Skeleton, Spin } from 'antd';
import Button from '@/shared/Button/Button';
import Activity from '@/shared/Activities/Activity';
import Colors from '@/constants/Colors';
import useTaskActivityConf from '@/v2/domains/Student/Tasks/hooks/useTaskActivityConf.hook';
import PreviewTaskActivityNav from './PreviewTaskActivityNav/PreviewTaskActivityNav';
import { usePreviewTaskStore } from '../previewTask.store';

export default function PreviewTaskBody({ task, onClose }) {
  const { setPreviewTaskOpen } = usePreviewTaskStore();
  const [selectedTaskActivity, setSelectedTaskActivity] = useState();

  useEffect(() => {
    if (task) {
      setSelectedTaskActivity(task.taskActivities?.[0]);
    }
  }, [task]);

  // TODO: remove this useEffect when we switch to v2
  useEffect(() => {
    setPreviewTaskOpen(true);
    return () => {
      setPreviewTaskOpen(false);
    };
  }, []);

  const { activity, activityConf, isLoading } =
    useTaskActivityConf(selectedTaskActivity);

  const taskActivityId = selectedTaskActivity?.id;
  return (
    <StyledTaskActivityDetail>
      <Spin spinning={isLoading}>
        <div className="task-activity-container">
          <div className="activity-detail">
            {activity ? (
              <>
                <div className="activity-header">
                  <IconWithTitle
                    title={activity.name}
                    subTitle={activity.englishName}
                    type={activity.type}
                    iconColor={Colors.activityTypeColors[activity.type]}
                  />

                  <Button onClick={onClose}>Close preview</Button>
                </div>
                <div className="activity-container">
                  <Activity
                    key={`${taskActivityId}${JSON.stringify(activityConf)}`}
                    activity={activity}
                    activityConf={activityConf}
                    taskActivityConf={selectedTaskActivity?.activityConf}
                    isPreview
                  />
                </div>
              </>
            ) : (
              <Skeleton active />
            )}
          </div>
          <div className="activity-nav">
            <PreviewTaskActivityNav
              taskActivities={task.taskActivities}
              currentTaskActivityId={selectedTaskActivity?.id}
              currentActivityId={activity?.id}
              currentMiniactivityType={activityConf?.miniactivityType}
              dueDate={task.dueDate}
              onSelectTaskActivity={(taskActivity) => {
                setSelectedTaskActivity(taskActivity);
              }}
            />
          </div>
        </div>
      </Spin>
    </StyledTaskActivityDetail>
  );
}
